module.exports = __webpack_public_path__ + "img/call-icon.f02985f1.svg";